<template>
  <card-seplag titulo="Gestão de Férias">
    <div class="divBusca p-col-12">
      <div class="p-grid p-align-end p-justify-center">
        <Rotulo cols="12 3" nome="Orgão">
          <Dropdown v-model="orgaoSelecionado" :options="listaOrgao" optionLabel="labelDropDaw"
            placeholder="Selecione..." filter :disabled="listaOrgao.length == 0" @change="carregarUnidade()" />
        </Rotulo>
        <Rotulo cols="12 3" nome="Setor:">
          <Dropdown v-model="unidadeSelecionado" :options="listaUnidades" optionLabel="labelDropDaw"
            placeholder="Selecione..." filter :showClear="!!unidadeSelecionado"
            :disabled="orgaoSelecionado && listaUnidades.length == 0" @change="alternarPaginas()" />
        </Rotulo>
        <div class="p-md-2 p-col-12">
          <Button label="Buscar" icon="pi pi-search" class="p-button-info" @click="carregarServidores()" />
        </div>
      </div>
    </div>
    <div class="p-grid p-col-12 botoes" v-if="orgaoSelecionado">
      <div class="p-md-4 p-col-12" @click="selecionarPagina('pendentes')">
        <!-- botões legenda: Pendentes | Deferidos | Não agendados -->
        <Card class="card-button estiloPendentes" v-if="mostrarPendentes">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Pendentes</span>
              </div>
              <!-- <div class="p-offset-2 p-col-2">
                <span
                  class="botao-quantidade-status"
                  style="margin-left: 1vw"
                  >{{
                    ("000" + this.countPendentes).slice(
                      this.countPendentes.toString().split("").length > 3
                        ? "-" + this.countPendentes.toString().split("").length
                        : -3
                    )
                  }}</span
                >
              </div> -->
            </div>
          </template>
        </Card>
        <Card class="card-button" v-else>
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Pendentes</span>
              </div>
              <!-- <div class="p-offset-2 p-col-2">
                <span
                  class="botao-quantidade-status"
                  style="margin-left: 1vw"
                  >{{
                    ("000" + this.countPendentes).slice(
                      this.countPendentes.toString().split("").length > 3
                        ? "-" + this.countPendentes.toString().split("").length
                        : -3
                    )
                  }}</span
                >
              </div> -->
            </div>
          </template>
        </Card>
      </div>
      <div class="p-md-4 p-col-12" @click="selecionarPagina('deferidos')">
        <Card class="card-button estiloDeferidos" v-if="mostrarDeferidos">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Validados</span>
              </div>
              <!-- <div class="p-offset-2 p-col-2">
                <span
                  class="botao-quantidade-status"
                  style="margin-left: 1vw"
                  >{{
                    ("000" + this.countDeferidos).slice(
                      this.countDeferidos.toString().split("").length > 3
                        ? "-" + this.countDeferidos.toString().split("").length
                        : -3
                    )
                  }}</span
                >
              </div> -->
            </div>
          </template>
        </Card>
        <Card class="card-button" v-else>
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Validados</span>
              </div>
              <!-- <div class="p-offset-2 p-col-2">
                <span
                  class="botao-quantidade-status"
                  style="margin-left: 1vw"
                  >{{
                    ("000" + this.countDeferidos).slice(
                      this.countDeferidos.toString().split("").length > 3
                        ? "-" + this.countDeferidos.toString().split("").length
                        : -3
                    )
                  }}</span
                >
              </div> -->
            </div>
          </template>
        </Card>
      </div>
      <div class="p-md-4 p-col-12" @click="selecionarPagina('acumulos')">
        <Card class="card-button estiloAcumulos" v-if="mostrarAcumulos">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Acúmulos</span>
              </div>
            </div>
          </template>
        </Card>
        <Card class="card-button" v-else>
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Acúmulos</span>
              </div>
            </div>
          </template>
        </Card>
      </div>
      <!-- <div class="p-md-4 p-col-12" @click="selecionarPagina('naoAgendados')">
        <Card class="card-button estiloNaoAgendados" v-if="mostrarNaoAgendados">
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Não Agendados</span>
              </div>
              <div class="p-offset-2 p-col-2">
                  <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countNaoAgendados).slice(this.countNaoAgendados.toString().split('').length> 3? "-"+this.countNaoAgendados.toString().split('').length:-3)}}</span>
              </div>
            </div>
          </template>
        </Card>
        <Card class="card-button" v-else>
          <template slot="content">
            <div class="p-grid">
              <div class="p-col-7">
                <span class="botao-titulo-status">Não Agendados</span>
              </div>
              <div class="p-offset-2 p-col-2">
                  <span class="botao-quantidade-status" style="margin-left: 1vw;">{{("000" + this.countNaoAgendados).slice(this.countNaoAgendados.toString().split('').length> 3? "-"+this.countNaoAgendados.toString().split('').length:-3)}}</span>
              </div>
            </div>
          </template>
        </Card>
      </div> -->
    </div>

    <div class="p-col-12" v-if="
      listaSevidores &&
      listaSevidores.content &&
      listaSevidores.content.length > 0
    ">
      <div class="p-col-12" style="margin-top: 10px" v-if="orgaoSelecionado">
        <div class="p-grid p-align-end p-justify-center">
          <Rotulo cols="12 3" nome="Filtro por Nome ou CPF:">
            <InputText type="text" v-model="filtro" />
          </Rotulo>
          <div class="p-md-2 p-col-12">
            <Button label="Filtrar" icon="pi pi-filter" class="p-button-info" @click="carregarServidores()" />
          </div>
        </div>
      </div>
      <table-seplag :dados="listaSevidores.content" :exibirCabecalho="false" :campos="[]" :paginacao="true"
        :onSearchPaginacao="carregarServidores" :totalRegistro="listaSevidores.totalElements">
        <Column field="idReg" header="ID">
          <template #body="slotProps">
            <p>{{ slotProps.data.idReg ? slotProps.data.idReg : "" }}</p>
          </template>
        </Column>
        <Column field="matricula" header="Matrícula">
          <template #body="slotProps">
            <p>{{ slotProps.data.matricula }}</p>
          </template>
        </Column>
        <Column field="nome" header="Nome Servidor" :bodyStyle="{ width: '30%' }">
          <template #body="slotProps">
            <p>
              {{ slotProps.data.nome }}<br /><span style="font-size: 11px; font-weight: 700">{{ slotProps.data.setor
                }}</span>
            </p>
          </template>
        </Column>
        <Column field="dataInicioDireitoAfastamento" header="Periodo Aquisitivo"
          headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento">
          <template #body="slotProps">
            <span>
              {{ slotProps.data.dataInicioDireitoAfastamento }} à
              {{ slotProps.data.dataFimDireitoAfastamento }}</span>
          </template>
        </Column>
        <Column field="dataInicio" header="Periodo de Usufruto" headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento" v-if="mostrarPendentes || mostrarDeferidos">
          <template #body="slotProps">
            <span>{{ slotProps.data.dataInicio }} à
              {{ slotProps.data.dataFim }}</span><br />
            <span v-if="slotProps.data.dataInicioTemporario">Alterado para {{ slotProps.data.dataInicioTemporario }} à
              {{ slotProps.data.dataFimTemporario }}</span>
          </template>
        </Column>
        <Column field="totalDias" header="Dias Solicitados" headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento" v-if="mostrarPendentes || mostrarDeferidos">
          <template #body="slotProps">
            <span> {{ slotProps.data.totalDias }}</span><br />
            <span style="font-size: 11px; font-weight: 700">{{
              slotProps.data.tipoJornada
            }}</span>
          </template>
        </Column>
        <Column field="qtdeSaldoDias" header="Saldo de Dias" headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento" v-else-if="mostrarNaoAgendados">
          <template #body="slotProps">
            <span> {{ slotProps.data.qtdeSaldoDias }}</span>
          </template>
        </Column>
        <Column field="origem" header="Origem">
          <template #body="slotProps">
            <p>{{ slotProps.data.origem }}</p>
          </template>
        </Column>
        <Column field="status" header="Situação" headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento" v-if="mostrarPendentes || mostrarDeferidos">
          <template #body="slotProps">
            <Button v-if="mostrarDeferidos" :label=slotProps.data.statusFerias
              :class="'p-button-outlined customer-badge status-' + slotProps.data.statusFerias"
              @click="mostrarDetalhes(slotProps.data)" />
            <span v-if="mostrarPendentes" :class="'customer-badge pading5 status-' + slotProps.data.statusFerias">{{
              slotProps.data.statusFerias == "PENDENTE" &&
                slotProps.data.dataInicioTemporario
                ? "PENDENTE ALTERAÇÃO"
                : slotProps.data.statusFerias
            }}</span>
            <br />
          </template>
        </Column>
        <Column field="status" header="Situação" headerClass="situacaoColunaFeriasAgendamento"
          bodyClass="botaoColunaSituacaoFeriasAgendamento" v-else-if="mostrarNaoAgendados">
          <template #body="slotProps">
            <span :class="'customer-badge status-' + slotProps.data.statusAfastamento
              ">{{ slotProps.data.statusAfastamento }}</span>
            <br />
            <span>{{ slotProps.data.statusAfastamentoDesc }}</span>
          </template>
        </Column>
        <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação" v-if="mostrarPendentes">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Ação'" @click="showModal(slotProps.data)"
              :disabled="!habilitaAgendamento" v-if="slotProps.data.origem != 'SEAP'"></Button>
          </template>
        </Column>
        <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação"
          v-if="habilitaCancelamento && mostrarDeferidos">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Ação'" @click="showModal(slotProps.data)"
              :disabled="!habilitaAgendamento" v-if="slotProps.data.origem != 'SEAP'"></Button>
          </template>
        </Column>
        <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação" v-else-if="mostrarNaoAgendados">
          <template #body="slotProps">
            <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Ação'"
              @click="showModalDataFerias(slotProps.data)" :disabled="!habilitaAgendamento"></Button>
          </template>
        </Column>
      </table-seplag>
    </div>

    <div class="p-col-12" v-if="mostrarAcumulos">
      <card-seplag titulo="FILTROS DE PESQUISA">
        <div class="flexContainer">
          <Rotulo class="flexItem p-md-2" nome="NOME/MATRÍCULA">
            <InputText v-model="searchQuery" type="text" placeholder="Digite nome ou matrícula" @change="filtrar()" />
          </Rotulo>
          <Rotulo class="flexItem p-md-2" nome="PERÍODOS EM ABERTO">
            <Dropdown v-model="periodo" :showClear="!!periodo" :options="periodos"
              placeholder="Selecione a opção desejada" @change="filtrar()" />
          </Rotulo>
          <Rotulo class="flexItem p-md-2" nome="TIPO NOTIFICAÇÃO">
            <Dropdown v-model="tipoNotificacao" :showClear="!!tipoNotificacao" :options="filtroTipoNotificacoes"
              @change="filtrar()" />
          </Rotulo>
          <Rotulo class="flexItem p-md-2" nome="TEMPO DE NOTIFICAÇÃO">
            <InputText placeholder="Maior que" v-model="tempoNotificacao" @change="filtrar()" />
          </Rotulo>
          <div class="flexItem p-md-2 p-col-12">
            <Button label="Filtrar" icon="pi pi-filter" class="p-button-info" @click="filtrar()" />
          </div>
          <div class="flexItem p-md-2 p-col-12">
            <Button label="Limpar" icon="pi pi-trash" class="p-button-warning" @click="limpar()" />
          </div>
        </div>
      </card-seplag>
      <card-seplag>
        <div class="p-col-12 divTabelaSetor" v-if="listaServidoresAcumulo.length > 0">

          <DataTable :value="listaServidoresAcumulo" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            selectionMode="multiple">
            <Column field="nome" header="Nome"></Column>
            <Column field="matricula" header="Matrícula"></Column>
            <Column field="vinculo" header="Vínculo"></Column>
            <Column field="periodosAbertos" header="Períodos Abertos"></Column>
            <Column header="Notificações">
              <template #body="slotProps">
                {{ slotProps.data.tipoNotificacaoEnum }}
              </template>
            </Column>
            <Column field="tempoNotificado" header="Tempo de Notificado"></Column>

            <Column headerStyle="width:7%;" :bodyStyle="'text-align: center;'">
              <template #header>
                <Checkbox v-model="selectAll" @change="toggleSelectAll" :disabled="desabilitarAlteracao" binary />
                <p style="margin-left: 10px;">Notificar</p>
              </template>
              <template #body="slotProps">
                <Checkbox :value="slotProps.data" v-model="selecionados" :disabled="desabilitarAlteracao"
                  @change="onSelectionChange" />
              </template>
            </Column>


            <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação">
              <template #body="slotProps">
                <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Ação'"
                  @click="showModalAgendamentoFeriasOficio(slotProps.data)" :disabled="agendado(slotProps.data)"
                  v-if="slotProps.data.tempoNotificado > 0"></Button>
              </template>
            </Column>



          </DataTable>
          <div class="p-col-12 p-grid p-align-end p-justify-end">
            <Rotulo class="p-md-2">
              <Dropdown v-model="tipo" :options="tipos" option-label="descricao" option-value="value"
                placeholder="Selecione o tipo de notificação" />
            </Rotulo>

            <div class="p-md-2">
              <Button label="Notificar" icon="pi pi-send" class="p-button-success" @click="notificar()" />
            </div>
            <div class="p-md-2">
              <Button label="Exportar para Excel" icon="pi pi-file-excel" class="p-button-info" @click="exportar()" />
            </div>
          </div>
        </div>
      </card-seplag>


    </div>
    <!-- MODAL DE VALIDAÇÃO -->
    <cadastro-rapido v-if="habilitaAgendamento" :tituloTela="mostrarDeferidos ? 'Indeferir Férias' : 'Definir Ação'"
      v-model="exibirTelaValidacaoPendente" :modoEdicao="'adicionar'" :onAdicionar="validaRegistro" optionValue="code"
      :textoButton="mostrarDeferidos ? 'Indeferir' : 'Salvar'">
      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{
              dadosAprovacao && dadosAprovacao.matricula
                ? dadosAprovacao.matricula
                : ""
            }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{
              dadosAprovacao && dadosAprovacao.nome ? dadosAprovacao.nome : ""
            }}
          </p>
          <p>
            <strong>Data Início: </strong>
            {{
              dadosAprovacao && dadosAprovacao.dataInicioTemporario
                ? dadosAprovacao.dataInicioTemporario
                : dadosAprovacao.dataInicio
            }}
          </p>
          <p>
            <strong>Data Fim: </strong>
            {{
              dadosAprovacao && dadosAprovacao.dataFimTemporario
                ? dadosAprovacao.dataFimTemporario
                : dadosAprovacao.dataFim
            }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Deferido" cols="12" v-if="!mostrarDeferidos">
        <SelectButton name="deferido" v-model="registro.statusProgramacao" :options="simNao" optionLabel="name"
          v-required />
      </Rotulo>
      <Rotulo nome="Justificativa de Indeferimento de Férias" cols="12">
        <Textarea v-model="registro.observacaoTemporaria" rows="5" cols="30" />
      </Rotulo>
    </cadastro-rapido>

    <!-- redmine #21983 -->
    <!-- MODAL EXIBIR DETALHAMENTO SITUACAO -->
    <Dialog header="APROVAÇÃO" :visible.sync="exibirDetalhes" :modal="true" :closable="true">
      <div class="p-col-12">
        <p>EM: &nbsp; {{ dataAprovacao }}</p>
        <p>POR: &nbsp; {{ matriculaAprovador }} &nbsp; - &nbsp; {{ nomeAprovador }}</p>
        <p>LOTACAO: &nbsp; {{ setorAprovador }}</p>
      </div>
    </Dialog>


    <!-- MODAL AGENDAMENTO FERIAS POR OFICIO -->

    <Dialog header="Agendamento Ferias Por Ofício" :visible.sync="exibirTelaAgendamentoFerias" :modal="true"
      :closable="true">
      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            {{
              dadosServidor && dadosServidor.nome ? dadosServidor.nome : ""
            }}
          </p>
          <p>
            <strong>Matricula: </strong>
            {{
              dadosServidor && dadosServidor.matricula
                ? dadosServidor.matricula
                : ""
            }}
          </p>
          <p>
            <strong>Vínculo: </strong>
            {{
              dadosServidor && dadosServidor.vinculo
                ? dadosServidor.vinculo
                : ""
            }}
          </p>
        </Fieldset>
      </div>
      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Agendamento mais ascendente</strong>
          </template>
          <p><strong>Inícío:</strong> {{ this.inicioAgendamentoMaisAscendente }} &nbsp; &nbsp; <strong>Término:</strong>
            {{
              this.terminoAgendamentoMaisAscendente }}</p>
        </Fieldset>
      </div>

      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Períodos Aquisitivos</strong>
          </template>

          <!-- Iterar sobre a lista de períodos -->
          <div v-for="(periodo, index) in listaPeriodosAquisitivos" :key="index" style="margin-top: 30px;"
            class="periodo-item">
            <p><strong>Período:</strong> {{ periodo.dataInicioPeriodoAquisitivoFormat }} à {{
              periodo.dataFimPeriodoAquisitivoFormat }} </p>
            <Rotulo nome="Saldo de dias de direito">
              <InputText type="button" disabled="true" v-model="periodo.totalSaldo" id="input_mostra_dias" />
            </Rotulo>
            <Rotulo cols="12 8">
              <Fieldset style="width: 700px; min-width: 400; max-width: 900px;"
                legend="Selecione a quantidade de dias pretendidos:"
                v-if="getTiposGozo(periodo, index) && getTiposGozo(periodo, index).length > 0">
                <SelectButton v-model="selectedTipoGozoOficio[index]" :options="itensTipoGozoOficio[index]"
                  optionLabel="name" :disabled="comSaldoPeriodoAnterior(index)"
                  @input="calcularDataOficio(selectedTipoGozoOficio[index])" />
                <br /><br />
                <div class="p-grid" v-if="selectedTipoGozoOficio[index] && selectedTipoGozoOficio[index].code != null">
                  <Rotulo cols="12 2" style="margin-top: 1.8%">
                    <div style="
                background-color: #b7d8b7;
                text-align: center;
                padding: 6px;
              " v-if="selectedTipoGozoOficio[index] && selectedTipoGozoOficio[index].code == 10">
                      <b>10</b> dias corridos
                    </div>
                    <div style="
                background-color: #7fbcec;
                text-align: center;
                padding: 6px;
              " v-if="selectedTipoGozoOficio[index] && selectedTipoGozoOficio[index].code == 15">
                      <b>15</b> dias corridos
                    </div>
                    <div style="
                background-color: #ffe399;
                text-align: center;
                padding: 6px;
              " v-if="selectedTipoGozoOficio[index] && selectedTipoGozoOficio[index].code == 20">
                      <b>20</b> dias corridos
                    </div>
                    <div style="
                background-color: #f8b7bd;
                text-align: center;
                padding: 6px;
              " v-if="selectedTipoGozoOficio[index] && selectedTipoGozoOficio[index].code == 30">
                      <b>30</b> dias corridos
                    </div>
                  </Rotulo>

                  <Rotulo nome="Data de início" id="integral_inicio" cols="12 5">
                    <v-date-picker v-model="data_inicio" @input="calcularDataOficio(selectedTipoGozoOficio[index])"
                      :max-date="max_date" :min-date="min_date" :model-config="datePikerConfig" :first-day-of-week="1"
                      :update-on-input="false" :masks="datePikermasks">
                      <template v-slot="{ inputValue, inputEvents }">
                        <input class="p-inputmask p-inputtext p-component" :value="inputValue" v-on="inputEvents" />
                      </template>
                    </v-date-picker>
                    <!-- <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="data_inicio" @input="calcularData()" /> -->
                    <!-- <Calendar :showIcon="true" v-model="data_inicio" dateFormat="dd/mm/yy" @input="calcularData()" /> -->
                  </Rotulo>
                  <Rotulo nome="Data de término" id="integral_fim" cols="12 4">
                    <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="data_fim" disabled="true" />
                    <!-- <Calendar   :showIcon="true" dateFormat="dd/mm/yy" v-model="data_fim" /> -->
                  </Rotulo>
                  <Rotulo nome="Agendar" cols="12 1" style="text-align: center" v-if="habilitaAgendamento">
                    <Button type="button" icon="pi pi-check" class="p-button-info"
                      @click="registrarFeriasOficio(periodo, selectedTipoGozoOficio[index])" />
                  </Rotulo>
                </div>



              </Fieldset>
            </Rotulo>
          </div>
        </Fieldset>
      </div>
    </Dialog>
    <!-- </cadastro-rapido> -->

    <!-- MODAL DE CADASTRO -->
    <cadastro-rapido v-if="habilitaAgendamento" tituloTela="Cadastro de Datas de Férias" :tamanhoTela="'30.vw'"
      v-model="exibirTelaNovaFerias" :modoEdicao="'adicionar'" :onAdicionar="adicionarRegistro" optionValue="code"
      :textoButton="'Salvar'">
      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{
              dadosFerias && dadosFerias.numrMatricula
                ? dadosFerias.numrMatricula
                : ""
            }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{
              dadosFerias && dadosFerias.nomeServidor
                ? dadosFerias.nomeServidor
                : ""
            }}
          </p>
          <p>
            <strong>Periodo Aquisitivo: </strong>
            {{
              dadosFerias && dadosFerias.dataInicioPeriodaAquisitivo
                ? dadosFerias.dataInicioPeriodaAquisitivo
                : ""
            }}
            -
            {{
              dadosFerias && dadosFerias.dataFimPeriodaAquisitivo
                ? dadosFerias.dataFimPeriodaAquisitivo
                : ""
            }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Dias de usufruto" cols="12">
        <SelectButton v-model="selectedTipoGozo" :options="tiposGozo" optionLabel="name" @input="calcularData()" />
      </Rotulo>
      <Rotulo cols="12 2" style="margin-top: 1%" v-if="selectedTipoGozo">
        <div style="background-color: #b7d8b7; text-align: center; padding: 6px"
          v-if="selectedTipoGozo && selectedTipoGozo.code == 10">
          <b>10</b> dias corridos
        </div>
        <div style="background-color: #7fbcec; text-align: center; padding: 6px"
          v-if="selectedTipoGozo && selectedTipoGozo.code == 15">
          <b>15</b> dias corridos
        </div>
        <div style="background-color: #ffe399; text-align: center; padding: 6px"
          v-if="selectedTipoGozo && selectedTipoGozo.code == 20">
          <b>20</b> dias corridos
        </div>
        <div style="background-color: #f8b7bd; text-align: center; padding: 6px"
          v-if="selectedTipoGozo && selectedTipoGozo.code == 30">
          <b>30</b> dias corridos
        </div>
      </Rotulo>
      <Rotulo nome="Data de início" id="integral_inicio" cols="12 5" v-if="selectedTipoGozo">
        <v-date-picker v-model="data_inicio" @input="calcularData()" :max-date="max_date" :min-date="min_date"
          :model-config="datePikerConfig" :update-on-input="false" :masks="datePikermasks">
          <template v-slot="{ inputValue, inputEvents }">
            <input class="p-inputmask p-inputtext p-component" :value="inputValue" v-on="inputEvents" />
          </template>
        </v-date-picker>
        <!-- /<InputMask
          mask="99/99/9999"
          placeholder="dd/mm/aaaa"
          v-model="data_inicio"
          @input="calcularData()"
        /> -->
      </Rotulo>
      <Rotulo nome="Data de término" id="integral_fim" cols="12 5" v-if="selectedTipoGozo">
        <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="data_fim" disabled="true" />
      </Rotulo>
    </cadastro-rapido>



  </card-seplag>

</template>

<script>
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import TableSeplag from "@/template/TableSeplag.vue";
import Column from "primevue/column";
import { baseApiUrl, simNao } from "@/config/global";
import moment from "moment";
import exportFromJSON from "export-from-json";
import { format } from 'date-fns';

const getDefaulValida = () => {
  return {
    chave: null,
    idReg: null,
    dataInicio: null,
    dataFim: null,
    qtdDiasAfastamento: null,
    matricula: null,
    numeroVinculo: null,
    observacaoTemporaria: "",
    matriculaAprovador: null,
    numeroVinculoAprovador: null,
    statusProgramacao: { name: "Não", code: "N" },
  };
};

export default {
  name: "gestaoFerias",
  components: { CardSeplag, Column, Rotulo, CadastroRapido, TableSeplag },
  data() {
    return {
      desabilitarAlteracao: false,
      selectAll: false,

      pagina: null,

      //Agendamento mais ascendente
      inicioAgendamentoMaisAscendente: null,
      terminoAgendamentoMaisAscendente: null,

      //filtros de pesquisa acumulos
      searchQuery: '',
      periodos: [],
      periodo: null,
      filtroTipoNotificacoes: [],
      tipoNotificacao: null,
      tempoNotificacao: '',

      //modal agendamento ferias oficio
      exibirTelaAgendamentoFerias: false,
      listaPeriodosAquisitivos: [],
      dadosServidor: null,
      selectedTipoGozoOficio: [],
      itensTipoGozoOficio: [],

      //modal detalhes situacao redmine #21983
      exibirDetalhes: false,
      matriculaAprovador: null,
      nomeAprovador: null,
      setorAprovador: null,
      dataAprovacao: null,

      //botao notificar
      //tipos: ['Email', 'Portal'],
      tipo: null,
      selecionados: [],
      tipos: [],

      mostrarPendentes: true,
      mostrarDeferidos: false,
      mostrarAcumulos: false,
      mostrarNaoAgendados: false,
      habilitaAgendamento: true,
      exibirTelaValidacaoPendente: false,
      exibirTelaNovaFerias: false,
      habilitaCancelamento: false,

      countPendentes: 0,
      countDeferidos: 0,
      countNaoAgendados: 0,
      countPublicadoseap: 0,

      listaOrgao: [],
      listaUnidades: [],
      listaSevidores: [],
      listaServidoresAcumulo: [],
      dadosAprovacao: [],
      tiposGozo: [],

      matricula: null,
      vinculo: null,
      idenPessoa: null,
      orgaoPrincipal: null,
      orgaoSelecionado: null,
      unidadeSelecionado: null,
      selectedTipoGozo: null,
      dadosFerias: null,
      filtro: "",
      setor: "",

      simNao: simNao,
      registro: getDefaulValida(),
      data_inicio: null,
      data_fim: null,
      min_date: moment().format(),
      datePikerConfig: {
        type: "string",
        mask: "DD/MM/YYYY",
      },
      datePikermasks: {
        input: "DD/MM/YYYY",
      },
    };
  },
  methods: {
    carregarDados() {
      this.matricula = parseInt(this.$store.getters.getMatricula);
      this.vinculo = parseInt(this.$store.getters.getVinculo);
      this.idenPessoa = parseInt(this.$store.getters.getIdenPessoa);

      this.orgaoPrincipal = parseInt(
        this.$store.getters.getUser.contaAcesso.pessoa
          .listaServidorOrgaoSetor[0].idenOrgao
      );
      this.habilitaCancelamento =
        this.$store.getters.getPerfilAcesso == "CENTRAL";
      this.habilitaCancelamento =
        this.$store.getters.getPerfilAcesso == "SISTEMA";

      this.$http.get(`${baseApiUrl}/feriasview/orgaosperfil`).then((res) => {
        this.listaOrgao = res.data.map(function (element) {
          return {
            ...element,
            labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
          };
        });
      });
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selecionados = [...this.listaServidoresAcumulo];
      } else {
        this.selecionados = [];
      }
    },
    onSelectionChange() {
      this.selectAll = this.selecionados.length === this.listaServidoresAcumulo.length;
    },
    carregarUnidade() {
      this.unidadeSelecionado = '';
      if (this.orgaoSelecionado) {
        this.$http
          .get(
            `${baseApiUrl}/feriasview/unidades/${this.orgaoSelecionado.idenOrgao}`
          )
          .then((res) => {
            this.listaUnidades = res.data.map(function (element) {
              return {
                ...element,
                labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
              };
            });
          });
      }
      this.alternarPaginas();
    },
    async notificar() {
      try {
        if (this.selecionados.length === 0 && !this.tipo) {
          this.$toast.add({
            severity: 'error',
            summary: 'Ação Necessária',
            detail: 'Selecione ao menos um servidor e o tipo de notificação',
            life: 5000
          });
        } else if (this.selecionados.length === 0) {
          this.$toast.add({
            severity: 'error',
            summary: 'Ação Necessária',
            detail: 'Selecione ao menos um servidor',
            life: 5000
          });
        } else if (!this.tipo) {
          this.$toast.add({
            severity: 'error',
            summary: 'Ação Necessária',
            detail: 'Selecione o tipo de notificação',
            life: 5000
          });
        } else {
          const res = await this.$http.post(`${baseApiUrl}/acumuloFerias/servidorAcumulo/notificar/${this.tipo.replace(/\s+/g, '')}`, JSON.stringify(this.selecionados));
          this.$toast.add({
            severity: 'success',
            summary: 'Ação Efetuada',
            detail: res.data,
            life: 5000
          });
          this.carregarServidores();
        }
      } catch (error) {
        console.error("Erro ao notificar servidores:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao notificar servidores",
          detail: error.message,
          life: 3000
        });
      }

    },
    exportar() {
      const data = this.listaServidoresAcumulo;
      const fileName = 'ServidorFeriasAcumulo';
      const exportType = exportFromJSON.types.csv;

      exportFromJSON({ data, fileName, exportType, delimiter: ';' });
    },
    filtrar() {
      this.listaServidoresAcumulo = this.listaSevidores.filter((lista) => {
        const nomeOuMatricula = lista.nome.toLowerCase().includes(this.searchQuery.toLowerCase()) || lista.matricula == this.searchQuery;
        const periodo = this.periodo ? lista.periodosAbertos == this.periodo : true;
        const tipoNotificacao = this.tipoNotificacao ? lista.tipoNotificacaoEnum.includes(this.tipoNotificacao) : true;
        /* const tipoNotificacao = this.tipoNotificacao ? lista.tipoNotificacaoEnum == this.tipoNotificacao : true; */
        const tempoNotificacao = this.tempoNotificacao ? lista.tempoNotificado >= this.tempoNotificacao : true;

        return nomeOuMatricula && periodo && tipoNotificacao && tempoNotificacao;
      });
    },
    limpar() {
      this.searchQuery = '';
      this.periodo = '';
      this.tipoNotificacao = '';
      this.tempoNotificacao = '';
      this.listaServidoresAcumulo = this.listaSevidores;
      this.tipo = '';
      this.selecionados = '';
      this.selectAll = false;
    },

    selecionarPagina(selected) {
      this.pagina = selected;
      this.alternarPaginas();
    },

    agendado(dados) {
      const response = this.$http.post(`${baseApiUrl}/extratoferias`,
        JSON.stringify(dados));
      const dias = response.data;
      var status = false;
      if (dias < 1) {
        status = true;
      }
      return status;
    },
    getTiposGozo(periodo, index) {
      var item = periodo.diasPossivelAgendamento.map(item => ({
        name: item.dias + " dias",
        code: item.dias,
      }));
      //this.selectedTipoGozoOficio[index] = item[0];
      this.itensTipoGozoOficio[index] = item;
      return item;
    },

    alternarPaginas() {
      this.limpar();
      if (this.pagina == "pendentes") {
        this.mostrarNaoAgendados = false;
        this.mostrarDeferidos = false;
        this.mostrarAcumulos = false;
        this.mostrarPendentes = true;
        this.tituloTabela = "Agendamentos Pendentes";
      } else if (this.pagina == "deferidos") {
        this.mostrarNaoAgendados = false;
        this.mostrarPendentes = false;
        this.mostrarAcumulos = false;
        this.mostrarDeferidos = true;
        this.tituloTabela = "Agendamentos Deferidos";
      } else if (this.pagina == "naoAgendados") {
        this.mostrarDeferidos = false;
        this.mostrarPendentes = false;
        this.mostrarAcumulos = false;
        this.mostrarNaoAgendados = true;
        this.tituloTabela = "Não Agendados";
      } else if (this.pagina == "publicadoseap") {
        this.mostrarDeferidos = false;
        this.mostrarPendentes = false;
        this.mostrarAcumulos = false;
        this.mostrarNaoAgendados = false;
        this.tituloTabela = "No SEAP";
      } else if (this.pagina == "acumulos") {
        this.mostrarDeferidos = false;
        this.mostrarPendentes = false;
        this.mostrarAcumulos = true;
        this.mostrarNaoAgendados = false;
        this.tituloTabela = "";
      }
      this.filtro = "";
      this.carregarServidores();
    },

    async carregarServidores(size = 10, page = 0) {
      if (!this.orgaoSelecionado) {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Orgao Obrigatório, Por favor Selecione um Orgão",
          life: 3000,
        });
        return;
      }

      let bodyRequest = {
        matricula: this.matricula,
        numeroVinculo: this.vinculo,
        codgOrgao: this.orgaoSelecionado.idenOrgao,
        orgaoSeap: this.orgaoSelecionado.codgSeap,
        setorSeap: this.unidadeSelecionado ? this.unidadeSelecionado.codgSeap : null,
        status: "",
        filtro: this.filtro,
      };
      try {
        if (this.mostrarNaoAgendados) {
          bodyRequest.status = "NAOAGENDADOS";
          const res = await this.$http.put(`${baseApiUrl}/feriasview/rh/lista?size=${size}&page=${page}`, JSON.stringify(bodyRequest));
          this.listaSevidores = res.data;
        } else if (this.mostrarPendentes) {
          bodyRequest.status = "PENDENTES";
          const res = await this.$http.put(`${baseApiUrl}/feriasview/rh/lista?size=${size}&page=${page}`, JSON.stringify(bodyRequest));
          this.listaSevidores = res.data;
        } else if (this.mostrarDeferidos) {
          bodyRequest.status = "APROVADOS";
          const res = await this.$http.put(`${baseApiUrl}/feriasview/rh/lista?size=${size}&page=${page}`, JSON.stringify(bodyRequest));
          this.listaSevidores = res.data;
        } else if (this.mostrarAcumulos) {
          let requestBody = {
            orgaoSeap: this.orgaoSelecionado.codgSeap,
            setorSeap: this.unidadeSelecionado ? this.unidadeSelecionado.codgSeap : null
          }
          const res = await this.$http.post(`${baseApiUrl}/acumuloFerias/servidorAcumulo`, JSON.stringify(requestBody));
          this.listaSevidores = res.data;
          this.listaServidoresAcumulo = this.listaSevidores;
          this.periodos = [...new Set(this.listaSevidores.map(lista => lista.periodosAbertos))].sort();
          this.filtroTipoNotificacoes = [...new Set(this.listaSevidores.flatMap(list => list.tipoNotificacaoEnum))];
          const resp = await this.$http.get(`${baseApiUrl}/acumuloFerias/tiposNotificacoes`);

          // Transformar o objeto em uma lista de objetos com 'value' e 'descricao'
          this.tipos = Object.entries(resp.data).map(([key, value]) => ({
            value: key,      // chave do enum (ex: "EMAIL_PORTAL")
            descricao: value // descrição associada à chave (ex: "Email e Portal")
          })).filter(item => item.value !== 'NAO_NOTIFICADO');

        }
      } catch (error) {
        console.error("Erro ao carregar servidores:", error);
        this.$toast.add({
          severity: "error",
          summary: "Erro ao carregar servidores",
          detail: error.message,
          life: 3000,
        });
      }
    },
    // redmine #21983
    mostrarDetalhes(data) {

      if (data.origem.toUpperCase() != "SEAP") {
        this.exibirDetalhes = true;
        if (data.aprovador != null) {
          const aprovadorString = data.aprovador;

          // Converte a string JSON em um objeto
          const aprovador = JSON.parse(aprovadorString);

          // Agora você pode acessar as informações do objeto 'aprovador'
          this.matriculaAprovador = aprovador.matricula;
          this.nomeAprovador = aprovador.nome;
          this.setorAprovador = aprovador.setor;
          // Converte e formata a data no formato dd/mm/yyyy
          this.dataAprovacao = format(new Date(aprovador.dataAprovacao), 'dd/MM/yyyy');
        } else {
          this.matriculaAprovador = null;
          this.nomeAprovador = null;
          this.setorAprovador = null;
          this.dataAprovacao = null;
        }
      }

    },
    carregaContador() {
      /*
          carrega os contadores dos botões "Pendentes", "Deferidos" e "Não agendados"
      */
      this.$http
        .get(
          `${baseApiUrl}/feriasview/rh/countador/${this.matricula}/${this.vinculo}/${this.orgaoSelecionado.idenOrgao}/PENDENTES`
        )
        .then((res) => {
          this.countPendentes = res.data;
        });

      this.$http
        .get(
          `${baseApiUrl}/feriasview/rh/countador/${this.matricula}/${this.vinculo}/${this.orgaoSelecionado.idenOrgao}/APROVADOS`
        )
        .then((res) => {
          this.countDeferidos = res.data;
        });

      // var v_countNA = this.$http.post(`${baseApiUrl}/direitoafastamentos/rh/count/naoagendados`, JSON.stringify(options))
      // if(v_countNA.status==200){
      //     this.countNaoAgendados = v_countNA.data
      // }
      this.carregarServidores();
    },    
    showModal(dados) {
      this.limparDados();

      this.registro.observacaoTemporaria = "";
      this.registro.chave = dados.chave;
      this.registro.idReg = dados.idReg;
      this.registro.dataInicio = dados.dataInicio;
      this.registro.dataFim = dados.dataFim;
      this.registro.qtdDiasAfastamento = dados.totalDias;
      this.registro.matricula = dados.matricula;
      this.registro.numeroVinculo = dados.numeroVinculo;

      this.dadosAprovacao = dados;

      this.exibirTelaValidacaoPendente = true;
    },
    async showModalAgendamentoFeriasOficio(dados) {
      this.limparDados();
      this.dadosServidor = dados;
      const res = await this.$http.get(`${baseApiUrl}/feriasview/listaperidoAquisitivoNotificado/${dados.matricula}/${dados.vinculo}`);
      const resMaisAscendente = await this.$http.get(`${baseApiUrl}/feriasview/agendamentoMaisAscendente/${dados.matricula}/${dados.vinculo}`);
      this.inicioAgendamentoMaisAscendente = resMaisAscendente.data.dataInicio;
      this.terminoAgendamentoMaisAscendente = resMaisAscendente.data.dataFim;
      this.listaPeriodosAquisitivos = res.data;
      this.exibirTelaAgendamentoFerias = true;
    },
    showModalDataFerias(dados) {
      this.limparDados();
      this.dadosFerias = dados;
      //console.log(this.dadosFerias)
      this.$http
        .get(
          `${baseApiUrl}/direitoafastamentos/${this.dadosFerias.idenDireitoAfastamento}`
        )
        .then((res) => {
          this.tiposGozo = [];
          this.selectedTipoGozo = null;
          this.saldoDias = res.data.qtdeSaldoDias + " dias";
          for (var item in res.data.periodoAfastamento) {
            var v_tiposGozo = {
              name: res.data.periodoAfastamento[item].dias + " dias",
              code: res.data.periodoAfastamento[item].dias,
            };
            this.tiposGozo.push(v_tiposGozo);
          }
          this.selectedTipoGozo = this.tiposGozo[0];
          this.calcularData();
          this.exibirTelaNovaFerias = true;
        });
    },
    validaRegistro() {
      //(this.orgaoSelecionado)
      if (
        this.registro.statusProgramacao.code == "N" &&
        this.registro.observacaoTemporaria.trim() == ""
      ) {
        this.$toast.add({
          severity: "error",
          summary:
            "A justificativa é OBRIGATORIA quando o pedido de Férias for negado",
          life: 3000,
        });
        return;
      }
      let situacao = "";
      if (this.registro.statusProgramacao.code == "S") {
        situacao = "APROVADO";
      } else {
        situacao = "REPROVADO";
      }
      let jsonBody = {
        ...this.registro,
        matriculaAprovador: this.$store.getters.getMatricula,
        numeroVinculoAprovador: this.$store.getters.getVinculo,
      };
      this.$http
        .put(
          `${baseApiUrl}/feriasview/rh/acao/${situacao}/${this.orgaoSelecionado.idenOrgao}`,
          JSON.stringify(jsonBody)
        )
        .then(() => {
          if (this.registro.statusProgramacao.code == "S") {
            this.$toast.add({
              severity: "success",
              summary:
                "Agendamento aprovado com Sucesso! Informações encaminhadas por email",
              life: 3000,
            });
          }
          if (this.registro.statusProgramacao.code == "N") {
            this.$toast.add({
              severity: "success",
              summary: "Agendamento atualizado com Sucesso!",
              life: 3000,
            });
          }
          this.carregaContador();
          this.exibirTelaValidacaoPendente = false;
        });
    },
    calcularDataOficio(selectedTipo) {

      if (selectedTipo) {
        if (this.data_inicio) {
          let checkData = this.data_inicio.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.split("");
          if (checkData.length > 7) {
            let data_i = new moment(this.data_inicio, "DD/MM/YYYY").locale(
              "pt-br"
            );
            let qtd_dias = selectedTipo.code - 1;
            let data_f = data_i.locale("pt-br").add(qtd_dias, "days");
            this.data_fim = data_f.locale("pt-br").format("L");
          } else {
            this.data_fim = null;
          }
        }

      }
    },
    async registrarFeriasOficio(periodo, selectedTipo) {
      let bodyRequest = {
        chave: periodo.chave,
        dataInicio: this.data_inicio,
        dataFim: this.data_fim,
        qtdDiasAfastamento: selectedTipo.code,
        matricula: this.dadosServidor.matricula,
        numeroVinculo: this.dadosServidor.vinculo,
        matriculaAprovador: this.$store.getters.getMatricula,
        numeroVinculoAprovador: this.$store.getters.getVinculo,
      };
      await this.$http.post(`${baseApiUrl}/feriasview/oficio`, JSON.stringify(bodyRequest)).then(() => {
        this.$toast.add({
          severity: "success",
          summary: "Agendamento por ofício realizado com sucesso!",
          life: 3000,
        });
      });
      this.showModalAgendamentoFeriasOficio(this.dadosServidor)
    },

    comSaldoPeriodoAnterior(index) {
      // Verifica se há saldo em algum período anterior      
      for (let i = 0; i < index; i++) {
        if (this.listaPeriodosAquisitivos[i].totalSaldo > 0) {
          return true; // Desabilita a seleção se houver saldo anterior
        }
      }
      return false; // Habilita a seleção se não houver saldo anterior
    },

    calcularData() {
      if (this.selectedTipoGozo) {
        if (this.data_inicio) {
          let checkData = this.data_inicio.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("_", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.replace("/", "");
          checkData = checkData.split("");
          if (checkData.length > 7) {
            let data_i = new moment(this.data_inicio, "DD/MM/YYYY").locale(
              "pt-br"
            );
            let qtd_dias = this.selectedTipoGozo.code - 1;
            let data_f = data_i.locale("pt-br").add(qtd_dias, "days");
            this.data_fim = data_f.locale("pt-br").format("L");
          } else {
            this.data_fim = null;
          }
        }
      }
    },
    limparDados() {
      this.selectedTipoGozoOficio = [];
      this.selectedTipoGozo = null;
      this.dadosFerias = null;
      this.data_fim = null;
      this.data_inicio = new moment().add(31, "day").format("DD/MM/YYYY");
      this.min_date = new moment().add(31, "day").format();
      this.max_date = new moment().add(31, "day").add(1, "year").format();
    },
    adicionarRegistro() {
      if (this.data_inicio == null) {
        this.$toast.add({
          severity: "error",
          summary: "Dados Ausentes",
          detail: "Informe a data de início",
          life: 4000,
        });
      } else {
        var programacaoAdicionada = {
          direitoAfastamento: {
            idenDireitoAfastamento: this.dadosFerias.idenDireitoAfastamento,
          },
          dataInicio: this.data_inicio,
          dataFim: this.data_fim,
          tipoJornada: "INTEGRAL",
          qtdDiasAfastamento: this.selectedTipoGozo.code,
        };

        this.$http
          .post(
            `${baseApiUrl}/programacaoafastamentos`,
            JSON.stringify(programacaoAdicionada)
          )
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Registro Adicionado com Sucesso!",
              life: 3000,
            });
            this.exibirTelaNovaFerias = false;
            this.limparDados();
            this.carregarDados();
          });
      }
    },
  },
  mounted() {
    this.carregarDados();
  },
  computed: {
    estiloPendentes() {
      return {
        estiloPendentes: this.mostrarPendentes,
        estiloOff: this.mostrarDeferidos || this.mostrarNaoAgendados,
      };
    },
    estiloDeferidos() {
      return {
        estiloDeferidos: this.mostrarDeferidos,
        estiloOff: this.mostrarPendentes || this.mostrarNaoAgendados,
      };
    },
    estiloNaoAgendados() {
      return {
        estiloDeferidos: this.mostrarNaoAgendados,
        estiloOff: this.mostrarPendentes || this.mostrarDeferidos,
      };
    },
    textoBusca() {
      if (this.mostrarPendentes) {
        return "Agendamentos Pendentes";
      } else if (this.mostrarDeferidos) {
        return "Agendamentos Deferidos";
      } else if (this.mostrarNaoAgendados) {
        return "Não Agendados";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.botoes {
  flex: auto;
  margin-top: 10px;
}

.left-side {
  justify-content: flex-end;
}

.flexContainer {
  width: 100vw;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-end;
  align-content: flex-end;

}

.flexItem {
  flex: 0 1 auto;
}

.estiloPendentes {
  background: rgb(219, 171, 81);
  color: aliceblue;
}

.estiloDeferidos {
  background: #0ca852;
  color: aliceblue;
}

.estiloAcumulos {
  background: #c0c0c0;
  color: aliceblue;
}

.estiloNaoAgendados {
  background: #f03a3a;
  color: aliceblue;
}

.estiloPublicoSEAP {
  background: #005494;
  color: aliceblue;
}

.estiloOff {
  background: #ccc;
  color: grey;
}

.pading5 {
  padding: 5px;
}

.status-FINALIZADO {
  background-color: #c8e6c9;
  color: #256029;
}

.status-FINALIZADO:active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-FINALIZADO:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-FINALIZADO:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}

.status-APROVADO {
  background-color: #c8e6c9;
  color: #256029;
}

.status-APROVADO:active {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:hover {
  background-color: #c8e6c9 !important;
  color: #256029 !important;
}

.status-APROVADO:focus {
  box-shadow: 0 0 0 0.2rem #c8e6c9;
}

.status-REPROVADO {
  background-color: #ffcdd2;
  color: #c63737;
}

.status-REPROVADO:active {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:hover {
  background-color: #ffcdd2 !important;
  color: #c63737 !important;
}

.status-REPROVADO:focus {
  box-shadow: 0 0 0 0.2rem #ffcdd2;
}

.status-PENDENTE {
  background-color: #feedaf;
  color: #8a5340;
}

.status-PENDENTE:active {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:hover {
  background-color: #feedaf !important;
  color: #8a5340 !important;
}

.status-PENDENTE:focus {
  box-shadow: 0 0 0 0.2rem #feedaf;
}

.status-PUBLICADO {
  background-color: #b3e5fc;
  color: #23547b;
}

.status-PUBLICADO:active {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:hover {
  background-color: #b3e5fc !important;
  color: #23547b !important;
}

.status-PUBLICADO:focus {
  box-shadow: 0 0 0 0.2rem #b3e5fc;
}

.status-VALIDADO {
  background-color: #eccfff;
  color: #694382;
}

.status-VALIDADO:active {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:hover {
  background-color: #eccfff !important;
  color: #694382 !important;
}

.status-VALIDADO:focus {
  box-shadow: 0 0 0 0.2rem #eccfff;
}

.status-AGENDADO_PARCIAL {
  background-color: #e0e79d;
  color: #8a5340;
}

.status-AGENDADO_PARCIAL:active {
  background-color: #e0e79d !important;
  color: #8a5340 !important;
}

.status-AGENDADO_PARCIAL:hover {
  background-color: #e0e79d !important;
  color: #8a5340 !important;
}

.status-AGENDADO_PARCIAL:focus {
  box-shadow: 0 0 0 0.2rem #e0e79d;
}

.card-selecionado {
  background-color: #00bcd4;
  color: aliceblue;
}

.botao-status {
  /*width:155px; */
  margin: 5px;
  border: 0;
  font-weight: bold;
  font-size: 13px;
}

.botao-acao {
  margin: 5px;
  font-size: 13px;
  /*width:145px;*/
}

.button-badge {
  position: absolute;
  font-size: 10px;
  right: -5px;
  top: -5px;
  min-width: 20px;
  min-height: 18px;
  text-align: center;
  line-height: 18px;
  color: #fff;
  background-color: #ef6262;
  padding: 2px;
  border-radius: 50%;
}

.setor-badge {
  display: inline-block;
  margin-left: 4px;
  font-size: 13px;
  min-width: 20px;
  min-height: 18px;
  line-height: 18px;
  text-align: center;
  color: #fff;
  background-color: #007be5;
  border-radius: 50%;
  padding: 2px;
}

.botao-titulo-status {
  font-size: 15px;
  font-weight: bold;
}

.botao-quantidade-status {
  background-color: #007be5;
  color: aliceblue;
  padding: 5px;
  font-size: 20px;
}

.card-button {
  cursor: pointer;
}
</style>

<style>
.situacaoColunaFeriasAgendamento>div {
  justify-content: center;
}

.botaoColunaSituacaoFeriasAgendamento {
  text-align: center !important;
}
</style>